import React from 'react';

/** Phone-shaped frame for live previews. The screen never scrolls sideways; long names wrap. */
function PhoneMock({ children, darkMode }: { children: React.ReactNode; darkMode?: boolean | undefined }) {
  return (
    <div className="mx-auto w-full max-w-[300px]">
      <div className="relative overflow-hidden rounded-[38px] border-[7px] border-zinc-900 bg-zinc-900 shadow-xl shadow-black/30 ring-1 ring-line">
        {/* Dynamic-island style notch */}
        <div className="absolute left-1/2 top-2 z-10 h-4 w-20 -translate-x-1/2 rounded-full bg-zinc-900" aria-hidden="true" />
        {/* Screen: always carries .dark so theme variables resolve, .preview-light overrides for the light preview */}
        <div className={`dark ${darkMode ? '' : 'preview-light'} max-h-[min(640px,calc(100vh-13rem))] overflow-y-auto overflow-x-hidden rounded-[30px] [overflow-wrap:anywhere]`}>
          {children}
        </div>
      </div>
    </div>
  );
}

export default PhoneMock;
